import React from 'react';

import {Helmet, useParams} from 'views/module';

import InboxScene from 'views/scenes/inbox/InboxScene';

const InboxPage = (props) => {
  const params = useParams();
  const conversationRn = params.conversationRn || undefined;

  return (
    <>
      <Helmet>
        <title>Quilt: Inbox</title>
      </Helmet>
      <InboxScene selectedConversationRn={conversationRn} />
    </>
  );
};

export default InboxPage;
